import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Offers a new version rather than installing one unannounced.
 *
 * Page order, rotation and split markers live in React state, so reloading
 * without asking would throw away work in progress. The documents themselves
 * are in IndexedDB and survive either way.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="update-prompt" role="status">
      <span>A new version is available.</span>
      <button className="btn btn--sm btn--primary" onClick={() => void updateServiceWorker(true)}>
        Reload
      </button>
      <button className="btn btn--sm btn--ghost" onClick={() => setNeedRefresh(false)}>
        Later
      </button>
    </div>
  );
}
